import React, { useRef, useState, useEffect } from "react"
import { Types } from "lib/@types"
import { appTools, cn, OPERATORS, CONVERSIONS } from "lib/utils"
import { useAppCtx, appStore } from "lib/state"
import { useConditional } from "lib/units/conditional"
import { useConditionalCtx } from "lib/units/dispute/statements/conditionals"

const labelClasses = "text-sm pl-1 text-amber-700"
const fieldClasses = "w-full px-2 py-[6px] bg-slate-700 dark:bg-slate-700 text-white text-sm focus:outline-none border border-solid border-slate-700 bg-transparent"
const buttonClasses = "px-5 py-1 text-white text-sm border border-solid"
const definitionClasses = "text-sm px-3"


export default function SpotlightApiDataItem({ closeFn, op }:{ closeFn:any; op?:Types.Apidata.ApidataObject }){

  const formRef = useRef(null) 

  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  const { updateFromSpotlight }:any = useConditional()
  const { currentConditional, updateConditional }:any = useConditionalCtx()

  const { update }:any = AppStore

  const [ formData, setFormData ] = useState<any>()
  const [ customInputType, setCustomInputType ] = useState<string>()
  const [ showDetails, setShowDetails ] = useState<boolean>(false)

  function handleInputChange(e:any){
    let { name, value } = e.target
    if( e.target === undefined ){
      name = "operator"
      value = e
    }
    setFormData({ ...formData, [name]: value })
  }

  function getInputType(item:any){
    const definedType = OPERATORS.find( (op:any) => op.value === item.operator )?.inputType
    if( customInputType ){
      return customInputType
    } else if ( definedType ){
      return definedType
    } else {
      return "text"
    }
  }

  function cleanupZones(newzones:any[]){
    const cleanzones = newzones.filter( (zone:any, idx:number) => idx === 0 || zone.groups.length > 0 )
    return cleanzones
    // update("actives.statement.conditional.zones", cleanzones)
  }

  function startCleanup(newzones:any[]){
    const cleanzones = newzones.map( (zone:any) => {
      const newgroups = zone.groups.filter( (group:any) => group.items.length > 0 )
      return { ...zone, groups: newgroups }
    })
    return cleanupZones(cleanzones)
    // update("actives.statement.conditional.zones", newzones)
  }

  function removeDropzoneItem(){
    const itemToRemove = store.metas.conditionalSpotlight.refid

    // All we are doing here is removing the targeted item from its group
    const newzones = currentConditional.zones.map( (zone:any) => {
      const newgroups = zone.groups.map( (group:any) => {
        if( group.items.includes(itemToRemove) ){
          const newitems = group.items.filter( (item:any) => item !== itemToRemove )
          return { ...group, items: newitems }
        } else {
          return group
        }
      })
      const result = { ...zone, groups: newgroups }
      return result
    })

    const newitems = currentConditional.items.filter( (item:any) => item.refid !== itemToRemove )
    const cleanzones = startCleanup(newzones)
    updateConditional({...currentConditional, zones: cleanzones, items: newitems })
    // update("actives.statement.conditional", { ...currentConditional, items: newitems, zones: cleanzones })
    closeFn()
  }

  function removeDataItem(e:any){
    e.preventDefault()
    if( store.metas.conditionalSpotlight.location === "clipboard" ){
      // removeClipboardItem()
    } else {
      removeDropzoneItem()
    }
  }

  function saveDataItem(e:any){
    e.preventDefault()
    if( store.metas.conditionalSpotlight.location === "clipboard" ){
      saveClipboardItems()
    } else {
      saveConditionalItem()
    }
  }

  // function saveConditionalItem(){
  //   console.log(formData)
  //   const itemIdx = currentConditional.items.findIndex( (item:any) => item.refid === store.metas.conditionalSpotlight.refid )
  //   console.log(itemIdx)
  //   update(`actives.statement.conditional.items[${itemIdx}]`, { ...currentConditional.items[itemIdx], ...formData })
  //   update("metas.conditionalSpotlight", { ...currentConditional.items[itemIdx], ...formData })
  // }

  function saveConditionalItem(){
    console.log(formData)
    const itemIdx = currentConditional.items.findIndex( (item:any) => item.refid === store.metas.conditionalSpotlight.refid )
    console.log(itemIdx)
    
    const updatedItems = currentConditional.items.map( (item:any, idx:number) => {
      if( idx !== itemIdx ) return item
      return { ...item, ...formData }
    })

    updateConditional({...currentConditional, items: updatedItems })

    // update(`currentConditional.items[${itemIdx}]`, { ...store.currentConditional.items[itemIdx], ...formData })
    update("metas.conditionalSpotlight", { ...currentConditional.items[itemIdx], ...formData })
  }

  function saveClipboardItems(){
    console.log(formData)
    const refid = currentConditional.clipboard.find( (item:any) => item.api_value_id === store.metas.conditionalSpotlight.apiValueObj._id )?.refid
    console.log(refid)
    const item = store.metas.conditionalSpotlight
    const data = { ...store.metas.conditionalSpotlight, ...formData, refid }
    console.log(data)

    // const dataToUpdate = { ...data, id: item.id, apiValueObj: item.apiValueObj }
    updateFromSpotlight(data)
    closeFn()
    // updateTestingData(data)
  }

  useEffect(() => {
    if( !formData ){
      if( store.metas.conditionalSpotlight !== undefined ){
        setFormData({...store.metas.conditionalSpotlight})
      } else {
        setFormData({ conversion: "", operator: "", value: "", alias: "", tag: "" })
      }
    }
  },[store.metas.conditionalSpotlight, formData])

  if(!formData) return <></>
  return (
    <div className={cn("w-full relative")}>
      { store.metas.conditionalSpotlight?.result !== undefined && (
        <div>
          <p className="leading-loose">This item has been given an auto-result of <span className="text-amber-700">{store.metas.conditionalSpotlight.result.toString()}</span>. This is typically done for testing purposes but can be used anytime you need to guarantee that a conditional passes or fails.</p>
        </div>
      )}
    
      { store.metas.conditionalSpotlight?.result === undefined && (
        <div className="w-full flex flex-col">
          <form ref={formRef} className="w-full flex flex-col gap-2">
                  
            <div className="w-11/12 mt-[-5px] mb-2 text-xs m-auto border-b border-solid border-slate-700 text-center pb-1">
              { store.metas.conditionalSpotlight?.apiValueObj?.label || "Undefined" }</div>

            <div className="w-full flex flex-col gap-[3px] mb-2">
              <span className={cn(labelClasses)}>Conversion</span>
              <div className="">
                <select name="conversion" value={formData.conversion} onChange={handleInputChange} className={cn(fieldClasses)}>
                  <option value="">Select a conversion...</option>
                  { CONVERSIONS.map( (convObj:any, idx:number) => (
                    <option key={idx} value={convObj.value}>{convObj.label}</option>
                  ))}
                </select> 
              </div>
            </div>

            <div className="w-full flex flex-col gap-[3px] mb-2">
              <span className={cn(labelClasses)}>Operator</span>
              <div className="">
                <select name="operator" value={formData.operator} onChange={handleInputChange} className={cn(fieldClasses)}>
                  <option value="">Select an operator...</option>
                  { OPERATORS.map( (opObj:any, idx:number) => (
                    <option key={idx} value={opObj.value}>{opObj.label}</option>
                  ))}
                </select> 
              </div>
            </div>

            <div className="w-full flex flex-col gap-[3px] mb-3">
              <span className={cn(labelClasses)}>Value ({getInputType(store.metas.conditionalSpotlight)})</span>
              <div className="">
                { getInputType(store.metas.conditionalSpotlight) === "boolean" ? (
                  <select name="value" value={formData.value} onChange={handleInputChange} className={cn(fieldClasses)}> 
                    <option value="">Select a value...</option>
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>
                ) : (
                  <input 
                    type={getInputType(store.metas.conditionalSpotlight)} 
                    name="value"
                    value={formData.value}
                    onChange={handleInputChange}
                    className={cn(fieldClasses)}
                    placeholder="Enter a value..."
                  />
                )}
                <div className="w-full flex justify-end items-center gap-2 text-xs pr-1 pt-1.5">
                  { ["text","number","boolean","date"].map( (type:string, idx:number) => (
                    <span key={idx} className="cursor-pointer hover:text-amber-700" onClick={() => setCustomInputType(type)}>
                      {type}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="w-full flex flex-col gap-[3px]">
              <span className={cn(labelClasses)}>Custom Alias (optional)</span>
              <div className="">
                <input 
                  type="text" 
                  name="alias" 
                  value={formData.alias || ""}
                  onChange={handleInputChange}
                  className={cn(fieldClasses)}
                  placeholder="Enter your custom alias..." 
                />
              </div>
            </div>

            <div className="w-full flex justify-end items-center gap-2 mt-4 pr-0">
              {/* <button type="button" className={cn(buttonClasses, "bg-transparent")} onClick={closeFn}>Close</button> */}
              <button type="button" className={cn(buttonClasses, "bg-transparent")} onClick={removeDataItem}>Remove</button>
              <button type="submit" className={cn(buttonClasses, "bg-green-900")} onClick={saveDataItem}>Save</button>
            </div>
          </form>
        </div>
      )}
    </div> 
  )
}